import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SubmissionAttachment } from '../../../../models/submissions/submission-attachment';
import { FileListItemComponent } from '../../../../ui/file-list-item/file-list-item.component';
import { AttachmentLinkPipe } from '../../../../pipes/attachment-link.pipe';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-submission-submitted-file-list',
  templateUrl: './submission-submitted-file-list.component.html',
  styleUrls: ['./submission-submitted-file-list.component.scss'],
  standalone: true,
  imports: [CommonModule, FileListItemComponent, AttachmentLinkPipe],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SubmissionSubmittedFileListComponent {
  @Input() files: SubmissionAttachment[] = [];
}
